module.exports = __webpack_public_path__ + "6e80a8d63e96eb993a657bc7337949a6.otf";